
import  axios  from 'axios';


export const DECODE_VIN_DATA = 'vin/DECODE_VIN_DATA';


export function decodeVinInStore(argVinDecode) {

    console.log("decodeVin retunr data is  " + argVinDecode );

    return {
        type: DECODE_VIN_DATA,
        decodedVinData:argVinDecode
    }
}



/********************* End of InStore calls **************************/




//Get list of vehicles

export function decodeVin(  argVin) {
    
    let trimedVin = argVin.trim();
    return (dispatch, getState) => {

        const state = getState();

        console.log("decodeVin is being called " );
        getDecodeVin(  trimedVin ).then(function(vehiclesList){
            console.log("decodeVin  "+ vehiclesList);
            var tempObject = buildTheVehcielInfoObject(vehiclesList.Results);
            dispatch(decodeVinInStore(tempObject));

    }, function(err){
        console.log("I had an error getting VIN Data" + err);
        });
    }//end of return
}

function getArrayOfGetsForDecodeVin(  argVin ){
  
    let baseUrl = "https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVin/"+argVin+"?format=json";
    console.log(" on getting vin decoded  the URL is " + baseUrl );

    var arrayOfGets = [];

    //if(argURL != null) {
        arrayOfGets.push(axios.get(baseUrl ));
    //}
    return arrayOfGets;
}

function getDecodeVin(   argVin ){

    var returnPromise = new Promise(function(resolve, reject){



        //if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfGetsForDecodeVin( argVin)).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log(" some error occured on getting vin decoded " + err.message  );
                reject(err);
            });
        //}
    });

    return returnPromise;
}

function buildTheVehcielInfoObject(argArray){

    //let i=0;
    let vehicleInfoObject={};
    let vehicleInfoText=null;
    let vMake=null;
    let vModel=null;
    let vYear=null;
    let vType=null;
    let vBody=null;
    let vDoors=null;
    let vErrorCode=null;
    let vErrorText=null;
    if(argArray != null){

       for(var i=0; i < argArray.length; i++ ){
            var tempObject = argArray[i];
            console.log("Object stuff is " +tempObject.Variable + " = "+ tempObject.Value );
           if(tempObject.Variable == "Error Code"){
        
               vErrorCode=tempObject.Value;
           }
           if(tempObject.Variable == "Error Text"){
        
               vErrorText=tempObject.Value;
           }
           if(tempObject.Variable == "Make"){

               vMake=tempObject.Value;
           }

           if(tempObject.Variable == "Model"){

               vModel=tempObject.Value;
           }
           if(tempObject.Variable == "Model Year"){

               vYear=tempObject.Value;
           }
           if(tempObject.Variable == "Vehicle Type"){

               vType=tempObject.Value;
           }
           if(tempObject.Variable == "Body Class"){

               vBody=tempObject.Value;
           }
           if(tempObject.Variable == "Doors"){

               vDoors=tempObject.Value;
           }
       }
        vehicleInfoText ='{"make":"'+vMake+
                            '", "model":"'+vModel+
                            '", "year":"'+vYear+
                            '", "type":"'+vType+
                            '", "body":"'+vBody+
                            '", "doors":"'+vDoors+
                            '", "errorCode":"'+vErrorCode+
                            '", "errorText":"'+vErrorText+
                            '"}';

        vehicleInfoObject  = JSON.parse(vehicleInfoText);
        return vehicleInfoObject;


    }





}
